import { REQUEST_SEGMENTS, SegmentActionTypes } from "./types";

import * as SegmentApi from "../../api/segmentApi";
import { isOk } from "../../result";
import { Segment } from "../../models/Segment";

function fetchSegments(segments: ReadonlyArray<Segment>): SegmentActionTypes {
  return {
    type: REQUEST_SEGMENTS,
    payload: segments
  };
}

export const thunkFetchSegments = () => async (dispatch: any) => {
  try {
    const segmentResult = await SegmentApi.list();
    if (isOk(segmentResult)) {
      dispatch(fetchSegments(segmentResult.value));
    }
  } catch (error) {
    console.log(error);
  }
};
